import Vue from 'vue'
import * as apis from '@apis'
const TaskAdd = {
  namespaced: true,
  state: {
    metadata: {},
    userdata: [],
    userDataTotalCount: 0,
    selectedTaskPerson: []
  },
  getters: {},
  mutations: {
    UPDATE_META_DATA (state, data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((item) => {
          Vue.set(state.metadata, item, data[item])
        })
      }
    },
    UPDATE_USER_DATA (state, data) {
      let list = data.persons || []
      state.userDataTotalCount = data.totalCount || 0
      if (Array.isArray(list)) {
        list.forEach(item => {
          item.headPhoto = item.headPhoto || ''
          item.id = item.userId
          item.code = item.userCode
          item.name = item.userName
        })
        state.userdata = list
      }
    }
  },
  actions: {
    FETCH_META_DATA ({commit}, params) {
      commit('UPDATE_META_DATA', params)
    },
    FETCH_TASKS_FOLDER_USERDATA ({commit}, params) {
      apis.MediaCloudNewsPlanTaskAdd.getTasksFolderUserdata(params).then(resp => {
        if (resp.data.status === 0) {
          commit('UPDATE_USER_DATA', resp.data.data)
        }
      })
    },
    UPDATE_SELECTED_TASK_PERSON ({state}, data) {
      let arr = state.selectedTaskPerson
      let person = data.person
      let type = data.type
      for (let i = 0, len = arr.length; i < len; i++) {
        let item = arr[i]
        if (item.id === person.id) {
          if (type === 'delete') {
            state.selectedTaskPerson.splice(i, 1)
          }
          return
        }
      }
      state.selectedTaskPerson.push(person)
    }
  }
}

export default TaskAdd
